export default __webpack_public_path__ + "static/media/deloitte-greenshield-stack1.webp";